export enum ReportStatus {
  Disabled = 'Disabled',
  Issue = 'Issue',
  Overdue = 'Overdue',
  Success = 'Success',
  Unknown = 'Unknown',
  Warning = 'Warning'
}
